import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getTest, getTestResult, startTest } from '@/services/tests';

export const tests = createQueryKeys('tests', {
  detail: (uuid: string) => ({
    queryFn: () => getTest(uuid),
    queryKey: [uuid],
  }),
  result: (uuid: string) => ({
    queryFn: () => getTestResult(uuid),
    queryKey: [uuid],
  }),
  start: (uuid: string) => ({
    queryFn: () => startTest(uuid),
    queryKey: [uuid],
  }),
});
